import React from "react";
import NavBar from "components/navigation/NavBar.js";
import {
  HStack,
  VStack,
  Box,
  Text,
  Heading,
  Stack,
  Button,
  Container,
  Image,
  Hide,
  Center,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import Pattern from "assets/images/pattern2.png";
import IllustrationImage1 from "assets/images/illustrationimage1.png";

const SearchForm = () => {
  return (
    <Box
      h="200px"
      p={5}
      w={{ base: "100%", md: "100%", lg: "60%" }}
      background="none"
    >
      <Center width="100%">
        <VStack align="stretch" minH="40px">
          <BannerText />
        </VStack>
      </Center>
    </Box>
  );
};

const BannerText = () => {
  return (
    <Box minH="30px" background="none">
      <Container p={0}>
        <Heading
          color="white"
          textAlign="start"
          as="h1"
          fontSize={{ base: "xl", sm: "2xl", md: "4xl", lg: "4xl" }}
          fontFamily="TrenchThin"
          fontWeight="bold"
        >
          Shop and pay globally with ease using Swaptrex&nbsp;
          <Text color="orange.500" as="span">
            Virtual Card
          </Text>
        </Heading>
        <Text
          mt={3}
          mb={1}
          color="white"
          textAlign="start"
          fontSize={{ base: "md", sm: "lg", md: "xl", lg: "xl" }}
          fontFamily="ManropeLight"
        >
          Experience the convenience of shopping and paying globally with our
          reloadable virtual debit card.
        </Text>
        {/*<Text
          mt={3}
          mb={1}
          color="white"
          textAlign="start"
          fontSize={{ base: "md", sm: "lg", md: "xl", lg: "xl" }}
          fontFamily="ManropeLight"
        >
          Payment no hard, na you dey use the wrong card
      </Text>*/}
      </Container>
      <Stack spacing={3} direction={"row"} mt="7" align="center">
        <Link to="/auth/signup">
          <Button
            rounded={"full"}
            px={6}
            colorScheme={"orange.500"}
            bg={"orange.500"}
            _hover={{ bg: "orange.100" }}
          >
            Get Started
          </Button>
        </Link>
        {/*
        <Link to="/auth/login">
          <Button rounded={"full"} px={6}>
            Login
          </Button>
        </Link>*/}
      </Stack>
    </Box>
  );
};

const Illustration = () => {
  return (
    <Hide below="md">
      <Box
        h="200px"
        p={5}
        w={{ base: null, md: null, lg: "40%" }}
        background="none"
      >
        <Image
          src={IllustrationImage1}
          width={{ base: "80%", sm: "80%", md: "80%" }}
          alt="Swaptrex Virtual Card"
        />
      </Box>
    </Hide>
  );
};

const BannerWithSearch = () => {
  return (
    <Box
      w="100%"
      background="brand.500"
      backgroundImage={`url(${Pattern})`}
      backgroundPosition="right center"
      backgroundSize="45% auto"
      backgroundRepeat="no-repeat"
      pb="7"
    >
      <HStack background="none">
        <NavBar zIndex="10" />
      </HStack>
      <HStack minH="400px" pb={20} background="none">
        <SearchForm />
        <Illustration />
      </HStack>
    </Box>
  );
};

export default BannerWithSearch;
